import apiEndpoints from '../lib/apiEndpoints';
import apiCall from './apiCall';
import config from '../config';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const signupApi = (payload) => {
  return apiCall({
    method: 'post',
    payload,
    endpoint: apiEndpoints.SIGN_UP,
    isAuthEndPoint: true,
    customOrigin: process.env.REACT_APP_SELF_SERVE_BASE_URL
  });
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const emailVerification = (payload) => {
  return apiCall({
    method: 'post',
    payload,
    endpoint: apiEndpoints.EMAIL_VERIFICATION,
    isAuthEndPoint: true,
  });
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const resendVerificationMail = (payload) => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.RESEND_VERIFICATION_MAIL(payload.token) +
      (payload.journey === 'partner-invite' ? '?journey=partner-invite' : ''),
    customOrigin: process.env.REACT_APP_SELF_SERVE_BASE_URL,
    isAuthEndPoint: true
  });
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const edgeOnboardApi = (payload, authParams) => {
  return apiCall({
    method: 'post',
    payload,
    endpoint: apiEndpoints.SALESFORCE_EDGE_SIGN_UP,
    isSalesForceEndPoint: true,
    customOrigin: authParams.instance_url,
    sf_access_token: authParams.access_token,
    sf_token_type: authParams.token_type,
  });
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const salesForceAuthApi = (payload) => {
  return apiCall({
    method: 'get',
    payload,
    endpoint: apiEndpoints.SALESFORCE_AUTH,
    customOrigin: config(process.env.REACT_APP_BUILD_ENV).API.API_BASE_URL
  });
};

export const resetPasswordWithTokenApi = (data: {
  passwordResetToken: string;
  captchaResponse?: string;
  newPassword: string;
  confirmPassword: string;
}): any => {
  return apiCall({
    method: 'post',
    payload: data,
    endpoint: apiEndpoints.RESET_PASSWORD_WITH_TOKEN,
    isAuthEndPoint: true,
  });
};
